var jquery = require('jquery');
var myname = 'Favs';
var data = [];
var LFPortal = null;

function _exists(reference){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	return (_findIdx(reference)>=0)?true:false;
}

function _findIdx(reference){
	reference = reference.toLowerCase();
	return data.findIndex(function(fav){
		return fav.reference.toLowerCase() === reference;
	});
}

function _add_item(fav){
	// console.log('%s._add_item() : nFav:%d', myname, data.length, fav);
	fav.isfav = true;
	data.push(fav);
	// console.log('nFav:%d', data.length);
}

function _remove_item(reference){
	// console.log('%s._remove_item(%s)', myname, reference);
	var idx = _findIdx(reference);
	if(idx < 0) return;
	data.splice(idx, 1);
}

function _handler(event){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	event.preventDefault();
	var isfav = _exists(event.data.reference);
	// console.log(event.data.reference, isfav);
	if(isfav){
		remove(event.data.reference);
	}else{
		add(event.data.reference);
	}
}

function _makeButton(reference, state){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	var btn = jquery('<button/>')
		.addClass('c-save-btn')
		.attr({type: 'button'})
		.data({reference: reference})
		.click({reference: reference}, _handler)
		.on('toggle', function(event, newstate){
			var _self = jquery(this);
			if(newstate){
				_self.html(
					'<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" aria-hidden="true"><path d="M35.399 3c-5.045 0-9.387 4.104-11.398 8.391-2.013-4.286-6.355-8.391-11.401-8.391-6.955 0-12.6 5.646-12.6 12.601 0 14.149 14.273 17.859 24.001 31.848 9.195-13.902 23.999-18.15 23.999-31.848 0-6.956-5.645-12.601-12.601-12.601z"></path></svg>'
					+ '<span class="c-save-btn__value">'
					+ LFPortal.$t('favourites.button.remove')
					+ '</span>'
				);
				_self.addClass('is-saved');
			}else{
				_self.html(
					'<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" aria-hidden="true"><path d="M35.399 3c-5.045 0-9.387 4.104-11.398 8.391-2.013-4.286-6.355-8.391-11.401-8.391-6.955 0-12.6 5.646-12.6 12.601 0 14.149 14.273 17.859 24.001 31.848 9.195-13.902 23.999-18.15 23.999-31.848 0-6.956-5.645-12.601-12.601-12.601z"></path></svg>'
					+ '<span class="c-save-btn__value">'
					+ LFPortal.$t('favourites.button.add')
					+ '</span>'
				);
				_self.removeClass('is-saved');
			}
		})
	;
	btn.trigger('toggle', state);
	return btn;
}


function _updateSingleListing(reference){
	// console.log('%s._updateSingleListing(%s)', myname, reference);
	// Look for listings and update their decoration
	// var listings = jquery('.c-listing .c-listing__item[data-reference="' + reference.toLowerCase() + '"]');
	var listings = jquery('[data-reference="' + reference.toLowerCase() + '"]');
	// console.log('Got %s,', listings.length);
	if(!listings.length){
		return;
	}
	listings.each(function(idx){
		// Decorate listings
		var _self = jquery(this);
		var isfav = _exists(reference);
		// console.log("Fav: %s", reference);
		jquery(':button.c-save-btn', _self).trigger('toggle', isfav);
	});
}

function _decorateListings(){
	// console.info('%s.%s()', myname, arguments.callee.name);
	// Look for marked up elements and decorate them with Add/Remove favourites buttons
	var listings = jquery('[data-reference]');

	if(!listings.length){
		return;
	}
		
	listings.each(function(idx){
		// Decorate listings
		var _self = jquery(this);
		var reference = _self.data('reference');
		var isfav = _exists(reference);
		// console.log("Fav: %s", ref);
		var btn = _makeButton(reference, isfav);
		if(_self.data('onmouseover')){
			// Add special event to handle style issues.
			btn.mouseenter(function(){
				_self.addClass(_self.data('onmouseover'));
			});
			btn.mouseleave(function(){
				_self.removeClass(_self.data('onmouseover'));
			});
		}
		_self.append(btn);
	});
}

function _removeDecoration(){
	// console.info('%s.%s()', myname, arguments.callee.name);
	// Look for marked up elements and decorate them with Add/Remove favourites buttons
	var buttons = jquery('[data-reference] button.c-save-btn');
	if(!buttons.length){
		return;
	}
	buttons.remove();
}

// Public methods

function init(P){
	// console.info('%s.%s()', myname, arguments.callee.name);
	LFPortal = P;
}

function setData(favs){
	// Add bulk data to favourites
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	favs.forEach(function(fav){
		fav.isfav = true;
		data.push(fav);
	});
	_decorateListings();
}

function clearData(){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	data = [];
	_removeDecoration();
}

function add(reference){
	// console.log('%s.add(%s)', myname, reference);
	// update favs
	if(!LFPortal.dataset.ok){
		// console.log('Not logged in.');
		return;
	}
	jquery.ajax({
			url:LFPortal.endpoint('favourite')
		,	method: 'POST'
		, dataType: 'JSON'
		, contentType: 'application/json; charset=utf-8'
		, headers: {'Authorization': LFPortal.token()}
		, data: JSON.stringify({reference:reference})
	})
	.done(function(data, textStatus, jqXHR){
		_add_item(data);
		_updateSingleListing(reference);
		LFPortal.gaevent('favAdd', reference);
		return;
	})
	.fail(function(xhr, status, errorThrown){
		// console.log(arguments);
	});
	return;
}

function remove(reference){
	// console.log('%s.%s()', myname, arguments.callee.name, arguments);
	if(!LFPortal.dataset.ok){
		// console.log('Not logged in.');
		return;
	}
	if(!_exists(reference)) return;
	// update favs
	jquery.ajax({
			url:LFPortal.endpoint('favourite/' + encodeURI(reference))
		,	method: 'DELETE'
		, dataType: 'JSON'
		, contentType: 'application/json; charset=utf-8'
		, headers: {'Authorization': LFPortal.token()}
	})
	.done(function(data, textStatus, jqXHR){
		// console.info('%s.%s()', myname, arguments.callee.name, arguments);
		_remove_item(reference);
		_updateSingleListing(reference);
		LFPortal.gaevent('favRemove', reference);
		return;
	})
	.fail(function(xhr, status, errorThrown){
		// console.log(arguments);
	});		
	return;
}

function share(){
	// console.log('%s.share()', myname);
	// Create/get public share token
	if(!LFPortal.dataset.ok){
		// console.log('Not logged in.');
		return;
	}
	jquery.ajax({
			url:LFPortal.endpoint('favourite/sharetoken')
		,	method: 'GET'
		, dataType: 'JSON'
		, contentType: 'application/json; charset=utf-8'
		, headers: {'Authorization': LFPortal.token()}
	})
	.done(function(data, textStatus, jqXHR){
		if(typeof data === 'string'){
			LFPortal.dataset.publicfavourite_token = data;
		}
		LFPortal.gaevent('FavCreateShareLink');
		return;
	})
	.fail(function(xhr, status, errorThrown){
	});
	return;
}

function unshare(){
	// console.log('%s.unshare()', myname);
	// Create/get public share token
	if(!LFPortal.dataset.ok){
		// console.log('Not logged in.');
		return;
	}
	jquery.ajax({
			url:LFPortal.endpoint('favourite/sharetoken')
		,	method: 'DELETE'
		, dataType: 'JSON'
		, contentType: 'application/json; charset=utf-8'
		, headers: {'Authorization': LFPortal.token()}
	})
	.done(function(data, textStatus, jqXHR){
		LFPortal.dataset.publicfavourite_token = null;
		LFPortal.gaevent('FavCreateRemoveLink');
		return;
	})
	.fail(function(xhr, status, errorThrown){
	});
	return;
}

export default {
	init,
	remove,
	add,
	setData,
	clearData,
	data,
	share,
	unshare,
	isFav: function(reference){
		return _exists(reference);
	}
};


// WEBPACK FOOTER //
// ./src/portal/favourites.js